import { configureStore } from "@reduxjs/toolkit";
import rootReducers from "../reducers/rootReducer";
import { loadState, saveState } from './localStorage';

const preloadedState = loadState();

const store = configureStore({
    reducer: rootReducers,
    preloadedState 
});

store.subscribe(() => {
  saveState(store.getState());
});

export default store;
